import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 py-8 px-4">
      <div className="container mx-auto text-center text-gray-400">
        <p>© {new Date().getFullYear()} Monjul Boruah. All rights reserved.</p>
        <p className="mt-2">Built with React and Tailwind CSS</p>
      </div>
    </footer>
  );
};

export default Footer;